import { Component, Input, OnInit } from '@angular/core';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-client-activated-tools',
  templateUrl: './client-activated-tools.component.html',
  styleUrls: ['./client-activated-tools.component.css']
})
export class ClientActivatedToolsComponent implements OnInit {
  
    @Input() info;
    userApps = [];
    loading = false;
    clientUtilities = [];
    toggleConfig = {
      queryId: 'activeDeactivateClientTool',
        queryParam1: this.commonFunctions.getSelectedClientId(),
        queryParam2: null,
        queryParam3: null,
        queryParam4: null,
        currentObj: null,
        bindingLabel: 'active',
        toggleLabelActive: 'Active',
    }; 
  
    constructor(private resolver: ResolverService,private apiConnector: ApiConnectorService,private guiFlow: GuiFlowService,private commonFunctions: FunctionsService) { }
  
    ngOnInit(): void {
      if(this.info && this.info.FK_ID_clientDetails){
        this.resolver.getBackendDataForQueryId('getThisClientApps',true,this.info.FK_ID_clientDetails);
        this.resolver.getBackendDataForQueryId('getClientUtilities',true,this.info.FK_ID_clientDetails);
        this.resolver.getBackendDataForQueryId('getClientTools',true,this.info.FK_ID_clientDetails);
      }else{
        debugger
      }
    }
  
    getCurrentClientApps(){
      /* if(!this.resolver.isLoading('getThisClientApps')){
        this.userApps = this.resolver.getDependency('getThisClientApps')['records'];
        return this.userApps;
      }else{
        return [];
      } */
        return [];
    }
  
    onVisibleSlide(currentApp){
      this.loading = true;
      let newStatus;
      currentApp.visible? newStatus = "0" : newStatus = "1";
      this.apiConnector.simpleQueryId('visibleHideClientApp',this.info.FK_ID_clientDetails,newStatus,currentApp.FK_ID_userApp,null,null).subscribe(obj => this.processChange(obj));
    }
  
    onActiveSlide(currentApp){
      this.loading = true;
      let newStatus;
      currentApp.active? newStatus = "0" : newStatus = "1";
      this.apiConnector.simpleQueryId('activeDeactivateClientApp',this.info.FK_ID_clientDetails,newStatus,currentApp.FK_ID_userApp,null,null).subscribe(obj => this.processChange(obj));
    }
  
    processChange(res){
      if(res){
        this.guiFlow.openSimpleSnackBar('Actualizado con éxito','success');
        this.loading = false;
      }else{
        this.guiFlow.openSimpleSnackBar('Error','error');
        this.loading = false;
      }
    }
  
    toBool(value){
      return value == 1 || value == '1'? true : false;
    }
  
    isLoading(){
      return this.resolver.isLoading('getThisClientApps');
    }
  
    onSlideToggleEvent(event,key,service){
      let queryId;
      key == 'active'? queryId = 'activeDeactivateClientApp': queryId = 'visibleHideClientApp';
      /* key == 'active'? queryId = 'enableDisableClientApp': queryId = 'showHideClientApp'; */
      
      /* this.loadingRow = true; */
      let newVal;
      event.checked? newVal = "1" : newVal = "0";
      service.visible = newVal;
      this.apiConnector.voyjaleasApiRequest(queryId,this.commonFunctions.getSelectedClientId(),newVal,service.id,null,service)
      .subscribe(
        (response) => {
              this.guiFlow.openSimpleSnackBar('Saved ✅', 'success');
              /* this.loadingRow = false; */
            },
        (error) => {
              this.guiFlow.reportError(error,'update clientApps');
              /* this.loadingRow = false; */
            }
        );
    }
  
    getClientUtilities(){
      if(!this.resolver.isLoading('getClientUtilities')){
        if(this.resolver.getDependency('getClientUtilities') && this.resolver.getDependency('getClientUtilities')['records']){
          this.clientUtilities = this.resolver.getDependency('getClientUtilities')['records'];
        }
        return this.clientUtilities;
      }else{
        return [];
      }
    }

    getClientProductsActive(){
      if(!this.resolver.isLoading('getClientTools')){
        if(this.resolver.getDependency('getClientTools') && this.resolver.getDependency('getClientTools')['records']){
          this.clientUtilities = this.resolver.getDependency('getClientTools')['records'];
        }
        return this.clientUtilities;
      }else{
        return [];
      }
    }

    toogleActive(product){
      this.loading = true;
      let newStatus;
      product.active? newStatus = "0" : newStatus = "1";
      this.apiConnector.voyjaleasApiRequest('activeDeactivateClientTool',this.info.FK_ID_clientDetails,product.id,newStatus,null,product).subscribe(obj => this.processChange(obj));
    }

  
  }
  